<template>
	<transition-group
		ref="list"
		:duration="duration"
		@before-enter="beforeEnter"
		@before-leave="beforeLeave"
		@after-enter="clearStyles"
		@after-leave="clearStyles"
	>
		<slot></slot>
	</transition-group>
</template>

<script>
	import '../style/_slide-transition.scss';

	import SlideTransition from '../mixins/slide-transition';

	export default {
		name: 'ListTransition',
		mixins: [SlideTransition]
	};
</script>